import Vitrines from '../../vitrines/Vitrines';
import { ButtonLoader } from '../../utils/ButtonLoader';
import {  useContext, useRef } from 'react';
import { AppContext, UserContext } from '../../../AppContextProvider';
import React, { useState, useEffect } from 'react';
import { useFetch } from '../../api/FetchApiData';
import RayonForm from '../rayon/RayonForm';
import CategoryForm from '../category/CategoryForm';
import ManifacturerForm from '../manufacturer/ManifacturerForm';
import { isMobile } from "react-device-detect";
import { MediaUrl } from '../../utils/Media';
import Popup from 'reactjs-popup';
import Select from 'react-select';
import { useNavigate, useParams } from 'react-router-dom';
import ToggleSwitch from '../../utils/ToggleSwitch';
import { useTranslation } from 'react-i18next';

if (isMobile)
    import('./MobAjoutArticle.css').then(() => {});
else
    import('./AjoutArticle.css').then(() => {});


function ArticleForm({selected=false,art, EditSelectedItem, RemoveSelectedItem, SelectKitItem,article})
{
    const [bg,setBg] = useState('white');
    const [notif,setNotif] = useState('');
    var qte = "";
    var btnValue = '+';

    useEffect(()=>{
        if(selected)
            setBg('lightgreen');
    },[])

    const OverStock = (value)=>{
        if(value>art.stock)
        {
            setBg('darkgray');
            setNotif('Stock disponible depassé.')
        }
        else
        {
            setBg('lightgreen');
            setNotif('')
        }
    }

    if(selected)
    {
        qte = <div style={{width:'100%',marginTop:'5px'}}>
                    <label style={{display:'inline-block',width:'40%'}}>Quantite : </label>
                    <input min={1} onChange={e=>{EditSelectedItem(art,e.target.value);OverStock(e.target.value)}} type="number" style={{display:'inline-block',width:'30%',verticalAlign:'middle',textAlign:'center',border:'none',borderRadius:'5px'}} defaultValue={1} />
                    <p style={{fontSize:'x-small'}}>{notif}</p>
                </div>;
        btnValue = '-';
    }

    const BtnHandle = ()=>{
        if(selected)
            RemoveSelectedItem(art);
        else
            SelectKitItem(art);
    }

    return(
        <div key={article.kit.indexOf(art)} style={{width:"98%",border:'1px solid lightgray',backgroundColor:bg,borderRadius:'5px',paddingTop:'5px',paddingBottom:'5px',marginBottom:'5px'}}>
            <img src={MediaUrl(art.image.image)} style={{width:'15%',verticalAlign:'middle',minHeight:'50px',borderRadius:'5px'}} />
            <div style={{width:'65%',display:'inline-block',verticalAlign:'middle',marginLeft:'5px',marginRight:'5px',textAlign:'left'}}>
                <h5 style={{margin:'auto',wordBreak:'break-all'}}>{art.title}</h5>
                <span style={{fontSize:'small',color:'gray',marginRight:'20px'}}>(Ref : {art.id})</span> 
                <span style={{fontSize:'small',color:'gray'}}>{qte}</span>
            </div>
        <input onClick={e=>{BtnHandle()}} type="button" style={{display:'inline-block',minHeight:'50px',borderRadius:'5px',width:'10%',verticalAlign:'middle'}} value={btnValue} />
    </div>
    )
}


function AjoutArticle({_article = null}) 
{
    const [rayons,setRayons] = useState([]);
    const [rayon,setRayon] = useState({name:'',id:'',image:null,is_new:true,categories:[]});
    const [articles,setArticles] = useState([]);
    const [article,setArticle] = useState({delivers:[],to_publish:true
        ,category:{name:'',id: null,characteristics:[], 
        dimensionnements:[]}, 
        manufacturer:{name:"name",id:null,phone:"",categories:[],logo:null,country:{name:"",zip:""}}, 
        images:[], documents:[], title:"", 
        kit:[], is_kit:false, stock:1, description:"", 
        info_tech:"", characteristics:[], dimensionnements:[], 
        price:0, delivery_price:0, delivery_from:"", 
        volume:0, poids:0, 
        payment_modes:[],
        is_location:false,
        is_giftcard:false,
    });
    const [manifactures,setManifactures] = useState([]);
    const [cat_manufactures,setCatManufactures] = useState([]);
    const RayonInputRef = useRef(null);
    const CategoryInputRef = useRef(null);
    const ManufacturerInputRef = useRef(null);
    const [AppState,setAppState] = useContext(AppContext);
    const [UserState,setUserState] = useContext(UserContext);
    const fetchData = useFetch({AppState,setAppState});
    const [loading,setLoading] = useState(false);
    const [displays,setDisplays] = useState({man:'none',cat:'none'});
    const [characteristics,setCaracteristics] = useState([]);
    const [dimensionnements,setDimensionnements] = useState([]);
    const [modesPaiement,setModePaiement] = useState(['Cash']);
    const deliversRef = useRef();
    const [delivers,setDelivers] = useState([])
    const navigator = useNavigate();
    const {id} = useParams();
    const {t} = useTranslation();
    const [btnSubmit,setBtnSubmit] = useState({loading:false,text:t('user-info.enregistrer'),bg:'skyblue'})
    const [InputColors,setInputColors] = useState({
        'title':'lightgray',
        'rayon':'lightgray',
        'category':'lightgray',
        'manufacturer':'lightgray',
        'price':'lightgray',
        'stock':'lightgray',
        'delivery_price':'lightgray',
        'description':'lightgray',
        'info_tech':'lightgray',
        'images':'lightgray',
        'documents':'lightgray',
        'caracteristics':'lightgray'

    });
    
    const [notification,setNotification] = useState({text:"",color:"black",display:'none'});

    const loadrayons = async ()=>{
        await fetchData.GetData('rayon/all/param/').then((jresponse)=>
        {
            if(jresponse.result)
            {
                console.log(jresponse);
                setRayons(jresponse.rayons);
            }
        }).catch((error)=>{
            console.log(error);
        });
    }

    const reinit_article=()=>
    {
        if(!!_article)
        {
            rayons.forEach(ray=>{
                ray.categories.forEach((cat)=>{
                    if(cat.id===_article.category.id)
                    {
                        setRayon({...ray,is_new:false});
                        setArticle({..._article,category:cat,dimensionnements:cat.dimensionnements,manufacturer:{..._article.manufacture,categories:[],country:{name:'',zip:''}}});
                    }
                })
            })
        }
        else
        {
            setArticle({
                ...article,
                category:{name:'',id: null,characteristics:[]},
                manufacturer:{name:"",id:null,phone:"",categories:[],dimensionnements:[],logo:null,country:{name:"",zip:""}},
                kit:[]
            });
        }
    }

    const loadmanufactures = async ()=>{
        await fetchData.GetData('manufacture/all/').then((jresponse)=>
        {
            console.log(jresponse);
            if(jresponse.result)
            {
                setManifactures(jresponse.manufactures);
                setCatManufactures(jresponse.manufacturers);
            }
        }).catch((error)=>{
            console.log(error);
        });
    }

    const loadArticle = async ()=>{
        if(!!id)
        {
            return fetchData.GetData('articles/?id='+id).then((result)=>{
                if(result.result)
                {
                    setArticle({
                        ...result.article,
                        price:result.article.price_euro,
                        category:{...result.article.category,characteristics:result.article.characteristics, dimensionnements:result.article.dimensionnements},
                        payment_modes:JSON.parse(result.article.payment_modes)});
                        setDimensionnements([...result.article.dimensionnements]);
                        //setCaracteristics([...result.article.caracteristics]);
                        //setArticle({...article,price:result.article.price});
                        return result.article;
                }
                else
                {
                    return null;
                }
            });
        }
        else{return null}
    }

    const deliver_option = (deliver)=>{
        return(
        <div>
            <img src={MediaUrl(deliver.logo.image)} style={{verticalAlign:'middle',width:'30px',height:'30px',borderRadius:'15px',display:'inline-block'}} />
            <div style={{display:'inline-block',verticalAlign:'middle',marginLeft:'20px'}}>
                <label style={{display:'block',width:'fit-content'}}>{deliver.title}</label>
                <label style={{fontSize:'small',width:'fit-content'}}>{t('produit.reference')} : {deliver.id}</label>
            </div>
        </div>)
    }

    const loadDelivers = async ()=>{
        await fetchData.PostData({},'delivers/filter/all/').then((result)=>{
            if(result.result)
            {
                const arr = []
                result.delivers.forEach((deliv)=>{
                    arr.push({
                        label:deliver_option(deliv),
                        value:deliv
                    })
                });
                setDelivers(arr);
            }
        })
    }

    useEffect(()=>{
        if(!UserState.auth)
            navigator('/');
    },[UserState.auth])

    useEffect(()=>{
        if(!UserState.auth && !UserState.is_staff)
            navigator('/');
        loadrayons().finally(()=>loadArticle()).finally((result)=>{loadmanufactures();}).finally(()=>{loadDelivers()});
    },[])

    useEffect(()=>{
        try{
            ManufacturerInputRef.current.clearValue();
            RayonInputRef.current.clearValue();
            CategoryInputRef.current.clearValue();
        }
        catch(error){}
        reinit_article();
        setDisplays({...displays,man:'none',cat:'none'});
    },[rayons])

    useEffect(()=>{
        if(article.id!==null && article.id!=='')
        {
            manifactures.forEach(m=>{
                if(m.id===article.manufacturer.id && ManufacturerInputRef.current && ManufacturerInputRef.current.getValue().length===0)
                {
                    ManufacturerInputRef.current.setValue(m);
                }
            });
        }
    },[manifactures])

    useEffect(()=>{
        if(!!rayon.id && rayon.id!=='')
        {
            var arr = [];
            setDisplays({...displays,cat:'block'});
            rayon.categories.forEach((cat)=>{
                cat.articles.forEach((art)=>{
                    arr.push(art);
                if(cat.id === article.category.id && CategoryInputRef.current && CategoryInputRef.current.getValue().length===0)
                    CategoryInputRef.current.setValue(cat);
                })
            });
            setArticles(arr);
        }
        else
            setDisplays({...displays,cat:'none'});
    },[rayon])

    useEffect(()=>{
        //console.log(article);
        var mans = [];
        manifactures.map((man)=>{
            let cat_ids = man.categories.map(cat=>cat.id);
            console.log(cat_ids,article.category);
            if(cat_ids.includes(article.category.id))
                mans.push(man);
        })
        if(!!article.category.id && article.category.id!=='')
        {
            setDisplays({...displays,man:'block'});
            
            setCatManufactures(mans);
            let arr = []
            let dims = []
            article.category.characteristics.forEach((char)=>{
                const exists = article.characteristics.find(_char=> _char.id === char.id && _char.name === char.name)
                if(!!exists)
                    arr.push({cat_char:char.id, name:char.name, value:exists.value});
                else    
                    arr.push({cat_char:char.id, name:char.name, value:char.default_value});
            })

            if(article.category.dimensionnements === undefined)
                article.category.dimensionnements = [];
            article.category.dimensionnements.forEach((char)=>{
                const exists = article.dimensionnements.find(_char=>_char.name === char.name);
                if(!!exists)
                    dims.push({id:exists.id, name:exists.name, value:exists.value,unite:exists.unite});
                else    
                    dims.push({id:char.id, name:char.name, value:char.value, unite:char.unite});
            })
            setCaracteristics([...arr]);
            setDimensionnements([...dims]);
        }
        else
            setDisplays({...displays,man:'none'});

        rayons.forEach(ray=>{
            ray.categories.forEach((cat)=>{
                if(cat.id===article.category.id)
                {
                    if(RayonInputRef.current && RayonInputRef.current.getValue().length === 0)
                        RayonInputRef.current.setValue(ray);
                }
                    
            })
        })
            
    },[article.category])

    useEffect(()=>{
        
        if(article.is_kit)
        {
            var price = 0;
            article.kit.forEach((art)=>{
                price = price + parseFloat(art.price)*parseInt(art.quantite);
            });
            setArticle({...article,price:price});
        }
    },[article.kit])

    useEffect(()=>{
        if(article.is_kit)
            setArticle({...article,manufacturer:{name:'Djamnazi',phone:'xxxxxxxxxxx',country:{name:"Comores", zip:'00'}}});
    },[article.is_kit])

    useEffect(()=>{
        if(!UserState.auth)
            setAppState({...AppState,page:<Vitrines />})
    },[UserState.auth])

    const CheckForm = ()=>
    {
        var ok = true;
        if(!('title' in article) || article.title.length<10 || article.title.length>200)
        {
            ok = false;setInputColors({...InputColors,title:"orangered"});
            setNotification({text:"Le champs titre n'est pas correctement rempli",color:'orangered'});
        }                
        if(!('price' in article || article.price === '0'))
        {
            ok = false;setInputColors({...InputColors,price:"orangered"});
            setNotification({text:"Le prix n'est pas correctement renseigner",color:'orangered'});
        }
        if(!('stock' in article))
        {
            ok = false;setInputColors({...InputColors,stock:"orangered"});
            setNotification({text:"Le stock n'est pas correctement renseigner",color:'orangered'});
        }
        if(!('category' in article) || article.category === null || article.category===undefined || article.category.id=== null || article.category.id=== undefined || article.category.id=== '')
        {
            ok = false;setInputColors({...InputColors,category:"orangered"});
            setNotification({text:"Aucune catégorie sélectionner",color:'orangered'});
        }
        if(!('description' in article || article.description.length < 10))
        {
            ok = false;setInputColors({...InputColors,description:"orangered"});
            setNotification({text:"La description n'est correctement fournie",color:'orangered'});
        }
        if(!('delivery_price' in article))
        {
            ok = false;setInputColors({...InputColors,delivery_price:"orangered"});
            setNotification({text:"Veuillez indiquer le prix de la livraison",color:'orangered'});
        }
        if(characteristics.length<2)
        {
            ok = false;setInputColors({...InputColors,caracteristics:"orangered"});
            setNotification({text:"au moins deux caracteristiques sont requis",color:'orangered'});
        }
        if(!article.is_kit)
        {
            if(!('manufacturer' in article) || article.manufacturer === null || article.manufacturer===undefined || article.manufacturer.id=== null || article.manufacturer.id=== undefined || article.manufacturer.id=== '')
            {
                ok = false;setInputColors({...InputColors,manufacturer:"orangered"});
                setNotification({text:"Vous devez indiquer le fabricant",color:'orangered'});
            } 
            return ok;
        }
        else
        {return ok;}
    }
    
    const SelectRayonInput = (value,action)=>
        {
            if(!!value)
            {
                setRayon({...rayon,name:value.name,id:value.id,is_new:false,categories:value.categories,image:value.image});
                setInputColors({...InputColors,rayon:'lightgray'});
                setNotification({text:"",color:'black'});
                try{
                    ManufacturerInputRef.current.clearValue();
                    CategoryInputRef.current.clearValue();
                }
                catch(error){console.log(error);}
            }
            else if(action.action=='menu-close' || action.action=='input-blur')
            {}
            else
            {
                setRayon({name:'',id:null,image:null,is_new:true,categories:[]})
                try{
                    ManufacturerInputRef.current.clearValue();
                    CategoryInputRef.current.clearValue();
                }
                catch(error){console.log(error);}
            }

    }

    const SelectCategoryInput = (value,action)=>
    {
        if(!!value)
        {
            setArticle({...article,category:{name:value.name,id:value.id,characteristics:value.characteristics, dimensionnements:value.dimensionnements}});
            setNotification({text:"",color:'black'});
            setInputColors({...InputColors,category:'lightgray'});
            try{
                ManufacturerInputRef.current.clearValue();
            }
            catch(error)
            {}
            
        }
        else if(action.action !== 'input-blur' && action.action !== 'menu-close')
        {
            setArticle({...article,category:{name:'',id:null,image:null,characteristics:[],dimensionnements:[]}})
            try{
                ManufacturerInputRef.current.clearValue();
            }
            catch(error)
            {}
        }
    }
    
    const HandleData = (htmlElement)=>
    {
        if(htmlElement.target.name!=='is_kit' && htmlElement.target.name!=='is_location' && htmlElement.target.name!=='is_giftcard')
        {article[htmlElement.target.name] = htmlElement.target.value.replace(/'/g,"''");setArticle({...article});}
        else
        {article[htmlElement.target.name] = htmlElement.target.checked;setArticle({...article,manufacturer:{name:"inconnu",phone:"xxxxxxxxxx",country:"{}"}});}
        setArticle({...article});
    }

    const SelectKitItem = (item)=>
    {
       if(!article.kit.includes(item))
        {article.kit.push({...item,quantite:1});
            setArticle({...article,kit:[...article.kit]});
        }
        //console.log(selArticles);
    }

    const EditSelectedItem = (item,quantite)=>
    {
        var index = article.kit.indexOf(item);
        item.quantite = quantite;
        article.kit[index] = item;
        var price = 0;
        article.kit.forEach((art)=>{
            price = price + parseFloat(art.price)*parseInt(art.quantite);
        });
        setArticle({...article,price:price});
    }

    const RemoveSelectedItem=(art)=>
    {
        article.kit.splice(article.kit.indexOf(art),1);
        var price = 0;
        article.kit.forEach((art)=>{
            price = price + parseFloat(art.price)*parseInt(art.quantite);
        });
        setArticle({...article,price:price});
    }

    const ShowArticles = ()=>{

        if(article.is_kit)
        {
            return(
            <div className="DivInput">
                <label>Articles </label>
                <div className="UserInput" style={{border:'none'}}>
                    <fieldset style={{border:'1px solid lightgray',borderRadius:'5px'}}>
                        <legend style={{width:'100%',height:'22px',borderRadius:'5px',paddingTop:'5px',backgroundColor:'lightgray',fontSize:'small'}}>Choisissez un article</legend>
                            <input type="search" placeholder="trouver un article" style={{width:"96%",height:'30px',textAlign:'center',margin:"5px",border:'1px solid lightgray', borderRadius:'5px'}} />
                            <div style={{maxHeight:'200px',overflowY:'scroll'}}>
                            {
                                articles.map((art)=>
                                {
                                    return(<ArticleForm selected={false} art={art} article={article} SelectKitItem={SelectKitItem} RemoveSelectedItem={RemoveSelectedItem} EditSelectedItem={EditSelectedItem} />);
                                })
                            }
                            </div>
                
                    </fieldset>
                    <fieldset style={{border:'1px solid lightgray',borderRadius:'5px',marginTop:'10px'}}>
                        <legend style={{width:'100%',height:'22px',borderRadius:'5px',paddingTop:'5px',backgroundColor:'lightgray',fontSize:'small'}}>Composition du Kit</legend>
                        <div style={{maxHeight:'200px',overflowY:'scroll'}}>
                        {
                            article.kit.map((art)=>
                            {
                                return(<ArticleForm selected={true} art={art} article={article} SelectKitItem={SelectKitItem} RemoveSelectedItem={RemoveSelectedItem} EditSelectedItem={EditSelectedItem} />);
                            })
                        }
                        </div>
                    </fieldset>
                </div>
            </div>);
        }
        else
            return ;
    }

    const HandleModesPaiement = (element) =>
    {
        if(element.target.checked)
        {
            modesPaiement.push(element.target.value);
        }
        else
        {
            modesPaiement.splice(modesPaiement.indexOf(element.target.value),1);
        }
        setModePaiement([...modesPaiement]);
    }
    
    const HandleSelectManifactureInput = (value,action)=>
    {
        if(!!value)
        {
            {setArticle({...article,manufacturer:{phone:value.phone,name:value.name,id:value.id,categories:value.categories,logo:value.logo,country:value.country}});}
        }
        else if(action.action !== 'input-blur' && action.action !== 'menu-close')
        {
            setArticle({...article,manufacturer:{name:"",id:null,phone:"",categories:[],logo:null,country:{name:"",zip:""}}});
        }
    }

    const Manufacture_Form = ()=>{
        if(!article.is_kit)
            {return(
                <div style={{display:displays.man}} className="DivInput">
                <label>{t('filters.fabricants')}</label>
                <div style={{borderColor:InputColors.manufacturer,padding:'5px'}} className='UserInput'>
                    <Select  name="manufactures" 
                        className="ajout-article-select"
                        isClearable
                        onChange={(value,action)=>{try{HandleSelectManifactureInput(value,null)}catch{}}}
                        onInputChange={(value,action)=>{HandleSelectManifactureInput(value,action)}}
                        options={cat_manufactures}
                        ref={ManufacturerInputRef}
                        placeholder={t('filters.fabricants')}
                    />
                    <div style={{textAlign:'center',margin:'10px'}}>
                        {(AppState.settings.lang==='fr') && <ManifacturerForm setManufacturers={setManifactures} setRayons={setRayons} rayons={rayons} action={"Nouveau"} />}
                        <ManifacturerForm setManufacturers={setManifactures} setRayons={setRayons} manufacturer={article.manufacturer} rayons={rayons} action={"Modifier"} />
                        <ManifacturerForm setManufacturers={setManifactures} setRayons={setRayons} manufacturers={manifactures} action={"Supprimer"} />
                    </div>
                </div>
            </div>
            );}
        else
            return ShowArticles()
    }

    const ExecAction = ()=>
    {
        if(!CheckForm())
            return;
        if(article.is_kit)
            article.manufacturer = {name:'Djamnazi', phone:'xxxxxxxxxx', country:{name:'Comoros', 'zip':'00'}}
        var kit_compo = [];
        if(article.is_kit && article.kit.length>0)
        {
            article.kit.forEach((art)=>{
                kit_compo.push({id:art.id,quantite:art.quantite})
            })
        }
        const _article = {
            title:article.title,
            stock:article.stock,
            approvisionnement:article.approvisionnement,
            is_kit:article.is_kit,
            is_location:article.is_location,
            characteristics: characteristics,
            dimensionnement:dimensionnements,
            price:article.price,
            delivers:article.delivers,
            volume:article.volume,
            poids:article.poids,
            payment_modes: JSON.stringify(modesPaiement),
            manufacturer:{
                name:article.manufacturer.name,
                id:article.manufacturer.id,
                phone:article.manufacturer.phone,
                country:JSON.stringify(article.manufacturer.country)
            },
            to_publish:article.to_publish,
            is_giftcard:article.is_giftcard,
            kit_compo:kit_compo,
            info_tech:article.info_tech,
            description:article.description,
            category:article.category.id,
            delivery_price:article.delivery_price,
            delivery_from:article.delivery_from,
        };
        var images = article.images;
        var documents = article.documents;
        var formdata = new FormData();
        formdata.append('article',JSON.stringify(_article));
        images.forEach((img)=>{
            formdata.append('images',img,img.name);
        });
        documents.forEach((doc)=>{
            formdata.append('documents',doc,doc.name);
        });
        setBtnSubmit({...btnSubmit,loading:true});        
        fetchData.PostFormData(formdata,'articles/').then(result=>
        {
            console.log(result);
            if(result.result)
            {
                setBtnSubmit({...btnSubmit,loading:false,text:'Ajouté avec succès',bg:'lightgreen'});
                setTimeout(()=>{setBtnSubmit({...btnSubmit,loading:false,text:'Enregistrer',bg:'skyblue'});navigator('/');},10000); 
            }
            else
            {
                setBtnSubmit({...btnSubmit,loading:false,text:'Erreur, reessayé plus tard',bg:'orangered'});
                setTimeout(()=>{setBtnSubmit({...btnSubmit,loading:false,text:'Enregistrer',bg:'skyblue'});},10000); 
            }
        });      
    }

    const UpdateArticle = ()=>{
        if(article.is_kit)
            article.manufacturer = {name:'Djamnazi', phone:'xxxxxxxxxx', country:{name:'Comoros', 'zip':'00'}}
        var kit_compo = [];
        if(article.is_kit && article.kit.length>0)
        {
            article.kit.forEach((art)=>{
                kit_compo.push({id:art.id,quantite:art.quantite})
            })
        }
        const _article = {
            id:Number(id),
            title:article.title,
            stock:article.stock,
            approvisionnement:article.approvisionnement,
            is_kit:article.is_kit,
            is_location:article.is_location,
            characteristics: characteristics,
            dimensionnements:dimensionnements,
            price:article.price,
            delivers:article.delivers,
            volume:article.volume,
            poids:article.poids,
            payment_modes: JSON.stringify(modesPaiement),
            manufacturer:{
                name:article.manufacturer.name,
                id:article.manufacturer.id,
                phone:article.manufacturer.phone,
                country:JSON.stringify(article.manufacturer.country)
            },
            kit_compo:kit_compo,
            to_publish:article.to_publish,
            info_tech:article.info_tech,
            description:article.description,
            category:article.category.id,
            delivery_price:article.delivery_price,
            delivery_from:article.delivery_from,
        };
        var images = article.images;
        var documents = article.documents;
        var formdata = new FormData();
        formdata.append('article',JSON.stringify(_article));
        images.forEach((img)=>{
            if(img instanceof Blob)
                formdata.append('images',img,img.name);
        });
        documents.forEach((doc)=>{
            if(doc instanceof Blob)
                formdata.append('documents',doc,doc.name);
        });
        setBtnSubmit({...btnSubmit,loading:true});
        fetchData.PutFormData(formdata,'articles/').then(result=>
        {
            console.log(result);
            if(result.result)
            {
                
                //setBtnSubmit({...btnSubmit,loading:false,text:'Ajouté avec succès',bg:'lightgreen'});
                //setTimeout(()=>{setBtnSubmit({...btnSubmit,loading:false,text:'Enregistrer',bg:'skyblue'});},5000); 
            }
            else
            {
                //setBtnSubmit({...btnSubmit,loading:false,text:'Erreur, reessayé plus tard',bg:'orangered'});
                //setTimeout(()=>{setBtnSubmit({...btnSubmit,loading:false,text:'Enregistrer',bg:'skyblue'});},5000); 
            }
        });
              
    }

    const FormatImage=(image)=>
    {
        try{
            return URL.createObjectURL(image);
        }
        catch{
            return MediaUrl(image.image);
        }
    }

    const RayonPop = (action)=>{
        var btn_text_value = "Nouveau";
        switch(action)
        {
        case "Modifier":
        {btn_text_value = t("ajout-produit.modifier");break;}
        case "Nouveau":
        {btn_text_value = t("ajout-produit.nouveau");break;}
        case "Supprimer":
        {btn_text_value = t("panier.supprimer");break;}
        default:
            break;
        }
        let bg = 'lightgreen';
        if(action === 'Modifier')
            bg = 'lightblue';
        else if(action === 'Supprimer')
            bg = '#FFCBCC';
        //console.log(rayon);
        return(<Popup trigger={<input disabled={action==="Modifier" && (rayon.id===null || rayon.id==='' || rayon.id===undefined)} className='btn-popup' style={{backgroundColor:bg}} value={btn_text_value} type='button' />}>
            {close =>(<RayonForm close={()=>{close();}} rayons={rayons} action={action} setRayons={setRayons} rayon={rayon} />)}
        </Popup>)
    }

    const CategoryPop = (action)=>{
        var btn_text_value = "Nouveau";
        switch(action)
        {
        case "Modifier":
        {btn_text_value = t("ajout-produit.modifier");break;}
        case "Nouveau":
        {btn_text_value = t("ajout-produit.nouveau");break;}
        case "Supprimer":
        {btn_text_value = t("panier.supprimer");break;}
        default:
            break;
        }
        let bg = 'lightgreen';
        if(action === 'Modifier')
            bg = 'lightblue';
        else if(action === 'Supprimer')
            bg = '#FFCBCC';
        return(<Popup trigger={<input disabled={action==="Modifier" && (article.category.id===null || article.category.id==='' || article.category.id===undefined)} className='btn-popup' style={{backgroundColor:bg}} value={btn_text_value} type='button' />}>
            {close =>(<CategoryForm action={action} close={()=>{close();}} setRayons={setRayons} category={article.category}  rayon={rayon} />)}
        </Popup>)
    }

    const SubmitBtns = ()=>{
        if(!!id)
        {return(
            <div className="DivInput" style={{textAlign:'center',border:'none',marginTop:'20px'}}>
                <div className="SaveItem" style={{margin:'10px',width:'200px',height:'40px',borderStyle:'none',borderRadius:'10px',display:'inline-block'}}>
                    <ButtonLoader style={{backGroundColor:btnSubmit.bg,fontSize:'x-small'}} loading={loading} onSubmit={e=>{UpdateArticle();}} text={btnSubmit.text} />    
                </div>
                <input style={{margin:'10px',fontSize:'small',width:'100px',height:'40px',backgroundColor:'#FFCBCC',borderStyle:'none',borderRadius:'10px',display:'inline-block'}} className="SaveItem" onClick={(e)=>{setAppState({...AppState,page:<Vitrines />});}} type="button" value={t("ajout-produit.annuler")} />
                <input style={{margin:'10px',width:'100px',height:'40px',backgroundColor:'#FF3434',borderStyle:'none',borderRadius:'10px',display:'inline-block'}} className="SaveItem" onClick={(e)=>{DeleteArticle();}} type="button" value={t("panier.supprimer")} />
            </div>
        )}
        else
        {
            return(
            <div className="DivInput" style={{textAlign:'center',border:'none',marginTop:'20px'}}>
                <div className="SaveItem" style={{margin:'10px',width:'200px',height:'50px',borderStyle:'none',borderRadius:'10px',display:'inline-block'}}>
                    <ButtonLoader style={{backGroundColor:btnSubmit.bg,fontSize:'x-small'}} loading={loading} onSubmit={e=>{ExecAction();}} text={btnSubmit.text} />    
                </div>
                <input style={{margin:'10px',width:'100px',fontSize:'x-small',height:'50px',backgroundColor:'#FFCBCC',borderStyle:'none',borderRadius:'10px',display:'inline-block'}} className="SaveItem" onClick={(e)=>{setAppState({...AppState,page:<Vitrines rayon="photovoltaique" />});}} type="button" value={"Annuler"} />
            </div>);
        }
    }

    const RemoveDocumentFile = (doc)=>{
        if(doc instanceof Blob)
        {
            article.documents.pop(doc);setArticle({...article});
        }
        else
        {
            fetchData.DeleteData(doc,'document/').then((result)=>{
                if(result.result)
                {article.documents.pop(doc);setArticle({...article});}
            })
        }
        
    }

    const RemoveImageFile = (image)=>{
        if(image instanceof Blob)
        {
            article.images.pop(image);setArticle({...article});
        }
        else{
            fetchData.DeleteData(image,'image/').then((result)=>{
                if(result.result)
                {article.images.pop(image);setArticle({...article});}
            })
        }
    }

    const DeleteArticle = ()=>{
        
        fetchData.DeleteData({id:id}, 'articles/').then((result)=>{
            if(result.result)
            {
                //setAppState({...AppState,page:<Vitrines />});
                navigator('/');
            }
        });
    }

    return (
        <div id="AjoutProduit">
            <fieldset id="MainFieldset">
                <div style={{textAlign:'center',border:'none',display:notification.display}} className='DivInput'>
                    <p style={{color:notification.color}}>{notification.text}</p>
                </div>
                <div className="DivInput">
                    <label>{t('authentication.nom')} </label>
                    <input defaultValue={article.title} style={{borderColor:InputColors.title}} onChange={e=>{
                            if(e.target.value.length>10 && e.target.value.length<60)
                            {HandleData(e);e.target.style.borderColor = 'black';setNotification({text:"",color:'black'})}
                            else
                            {
                                e.target.style.borderColor = 'orangered';
                                setNotification({text:"Le titre doit avoir au moins 10 caractère et au plus 50",color:'orangered'})
                            }
                        }} className="UserInput" name="title" type="text" placeholder="Titre de l'article"/>
                </div>
                <div className="DivInput">
                    <label>{t('filters.rayons')} </label>
                    <div className='Div-UserInput' style={{borderColor:InputColors.rayon}}>
                        <Select  name="rayon"
                            className='ajout-article-select'
                            isClearable = {false}
                            onChange={(value,action)=>{try{SelectRayonInput(value,null);}catch{}}}
                            onInputChange={(value,action)=>{SelectRayonInput(value,action)}}
                            options={rayons}
                            ref={RayonInputRef}
                            isMulti={false}
                            isSearchable={false}
                        />
                        <div style={{textAlign:'center',margin:'10px'}}>
                            {(AppState.settings.lang==='fr') && RayonPop("Nouveau")}
                            {RayonPop("Modifier")}
                            {RayonPop("Supprimer")}
                        </div>
                    </div>
                </div>
                <div style={{}} className="DivInput">
                    <label>{t('filters.categories')}</label>
                    <div style={{borderColor:InputColors.category}} className='Div-UserInput'>
                        <Select  name="categories"
                                isClearable = {false}
                                className="ajout-article-select"
                                isSearchable = {false}
                                onChange={(value,action)=>{try{SelectCategoryInput(value,null);}catch{}}}
                                onInputChange={(value,action)=>{SelectCategoryInput(value,action)}}
                                options={rayon.categories}
                                ref={CategoryInputRef}
                                isMulti={false}
                        />
                        <div style={{textAlign:'center',margin:'10px'}}>
                            {CategoryPop("Modifier")}
                        </div>
                    </div>
                </div>
                <div className="DivInput">
                    <label></label>
                    <div className="Div-UserInput" style={{display:'inline-block',textAlign:'center'}}>
                        <div style={{marginRight:'10px',width:'30%',display:'inline-block'}}>
                            <label style={{width:'60%'}}>Carte Cadeau : </label>
                            <input disabled={!!article.id} style={{height:'15px',width:'15px'}}  onChange={e=>{HandleData(e);}} name="is_giftcard" className="UserInput" type="checkbox" defaultValue={article.is_giftcard}/>
                        </div>
                        { (!article.is_giftcard) &&
                        <>
                            <div style={{marginRight:'10px',width:'30%',display:'inline-block'}}>
                                <label style={{width:'60%'}}>Composé : </label>
                                <input style={{height:'15px',width:'15px'}}  onChange={e=>{HandleData(e);}} name="is_kit" className="UserInput" type="checkbox" defaultValue={article.is_kit}/>
                            </div>
                            <div style={{marginRight:'10px',width:'30%',display:'inline-block'}}>
                                <label style={{width:'60%'}}>Location : </label>
                                <input style={{height:'15px',width:'15px'}}  onChange={e=>{HandleData(e);}} name="is_location" className="UserInput" type="checkbox" defaultValue={article.is_kit}/>
                            </div>
                        </>
                        }
                        <div style={{marginRight:'10px',width:'30%',display:'inline-block'}}>
                            <label style={{width:'60%'}}>Publier : </label>
                            <input style={{height:'15px',width:'15px'}}  onChange={e=>{HandleData(e);}} name="to_publish" className="UserInput" type="checkbox" defaultValue={article.to_publish}/>
                        </div>
                    </div>
                </div>
                <div style={{display:displays.man}} className='DivInput'>
                    <label>{t('filters.caracteristiques')} </label>
                    <div style={{borderColor:InputColors.caracteristics}} className='Div-UserInput'>
                        {characteristics.map((car,index)=>{
                            return(
                                <div key={index} style={{width:'100%',marginTop:'5px'}}>
                                    <input name={index.toString()} style={{display:'inline-block',width:'30%',margin:'2px'}} placeholder = {t('authentication.nom')} value={car.name}  onChange={e=>{characteristics[index].name = e.target.value; setCaracteristics([...characteristics]);}} className="UserInput" type="text"/>
                                    <input name={index.toString()} style={{display:'inline-block',width:'30%',margin:'2px'}} placeholder = {t('ajout-produit.default-value')} value={car.value}  onChange={e=>{characteristics[index].value = e.target.value; setCaracteristics([...characteristics]);}} className="UserInput" type="text"/>
                                    <input onClick={e=>{characteristics.splice(index,1);setCaracteristics([...characteristics]);}} name={index.toString()} style={{backgroundColor:'#FFCCCB',margin:'2px',fontSize:'x-small',borderRadius:'5px',border:'none',width:'25%',display:'inline-block',height:'35px',padding:'0px 10px 0px 10px',margin:'0px'}} type='button' value={t("panier.supprimer")} />
                                </div>)
                        })}
                    </div>
                </div>
                <div style={{display:displays.man}} className='DivInput'>
                    <label>Dimensionnement : </label>
                    <div style={{borderColor:InputColors.caracteristics}} className='Div-UserInput'>
                        {dimensionnements.map((car,index)=>{
                            return(
                                <div key={index} style={{width:'100%',marginTop:'5px'}}>
                                    <input name={index.toString()} style={{display:'inline-block',disabled:true,width:'21%',margin:'2px'}} placeholder = 'name' value={car.name}  onChange={e=>{dimensionnements[index].name = e.target.value; setDimensionnements([...dimensionnements]);}} className="UserInput" type="text"/>
                                    <input name={index.toString()} style={{display:'inline-block',width:'21%',margin:'2px'}} placeholder = 'value' value={car.value}  onChange={e=>{dimensionnements[index].value = e.target.value; setDimensionnements([...dimensionnements]);}} className="UserInput" type="text"/>
                                    <input name={index.toString()} style={{display:'inline-block',disabled:true,width:'21%',margin:'2px'}} placeholder = 'value' value={car.unite}  onChange={e=>{dimensionnements[index].unite = e.target.value; setDimensionnements([...dimensionnements]);}} className="UserInput" type="text"/>
                                    <input onClick={e=>{dimensionnements.splice(index,1);setDimensionnements([...dimensionnements]);}} name={index.toString()} style={{backgroundColor:'#FFCCCB',margin:'2px',fontSize:'x-small',borderRadius:'5px',border:'none',width:'25%',display:'inline-block',height:'35px',padding:'0px 10px 0px 10px',margin:'0px'}} type='button' value={t("panier.supprimer")} />
                                </div>)
                        })}
                    </div>
                </div>
                {Manufacture_Form()}
                <div className="DivInput">
                    <label>{t('ajout-produit.prix')} </label>
                    <input value={article.price} style={{borderColor:InputColors.price}} step={"0.01"}  onChange={e=>{HandleData(e);}} name="price" className="UserInput" type="number" defaultValue={article.price}/>
                </div>
                <div className="DivInput">
                    <label>{t('ajout-produit.livraison-defaut')} </label>
                    <input style={{borderColor:InputColors.price}} value={article.delivery_price} step={"0.01"}  onChange={e=>{HandleData(e);}} name="delivery_price" className="UserInput" type="number" defaultValue={article.delivery_price}/>
                </div>
                <div className="DivInput">
                    <label>{t('ajout-produit.stock')} </label>
                    <input style={{borderColor:InputColors.stock}} value={article.stock}  onChange={e=>{HandleData(e);}} name="stock" className="UserInput" type="number" defaultValue={article.stock}/>
                </div>
                <div className="DivInput">
                    <label>{t('ajout-produit.approvisionnement')} </label>
                    <input style={{borderColor:InputColors.stock}}  onChange={e=>{HandleData(e);}} name="approvisionnement" className="UserInput" type="date" defaultValue={article.approvisionnement}/>
                </div>
                <div className="DivInput">
                    <label>{t('ajout-produit.depot')} </label>
                    <select  onChange={e=>{HandleData(e);}} name="delivery_from" className="UserInput">
                        <option>Comores</option>
                        <option>France</option>
                        <option>Turquie</option>
                        <option>Arabie Saoudite</option>
                    </select>
                </div>
                <div className="DivInput">
                    <label>{t('ajout-produit.volume')} </label>
                    <input placeholder='1' value={article.volume} onChange={e=>{HandleData(e);}}  name="volume" className="UserInput" type="number" defaultValue={article.volume}/>
                </div>
                <div className="DivInput">
                    <label>{t('ajout-produit.poids')} </label>
                    <input placeholder='1' value={article.poids} onChange={e=>{HandleData(e);}}  name="poids" className="UserInput" type="number" defaultValue={article.poids}/>
                </div>
                <div style={{}} className="DivInput">
                    <label>{t('ajout-produit.livreurs')} </label>
                    <div style={{borderColor:InputColors.category}} className='Div-UserInput'>
                        <Select  name="livreurs"
                                isClearable = {true}
                                className="ajout-article-select"
                                isSearchable = {true}
                                value={delivers.filter(opt => article.delivers.includes(opt.value.id))}
                                onChange={(value,action)=>{
                                    const arr = [];
                                    value.forEach((v)=>{
                                        arr.push(v.value.id)
                                    });
                                    setArticle({...article,delivers:arr});
                                }}
                                onInputChange={(value,action)=>{}}
                                options={delivers}
                                ref={deliversRef}
                                isMulti={true}
                        />
                    </div>
                </div>
                <div className="DivInput">
                    <label>{t('produit.description')} </label>
                    <textarea defaultValue={article.description} placeholder='Ajouter la description complète de votre article' style={{borderColor:InputColors.description,minHeight:'60px'}}  onChange={e=>{HandleData(e);}} name="description" className="UserInput"/>
                </div>
                <div className="DivInput">
                    <label>{t('ajout-produit.info-tech')} </label>
                    <textarea defaultValue={article.info_tech} placeholder='Ajouter quelques infos supplémentaire, des méthodes techniques ou des recommendations liés à votre article ' style={{minHeight:'60px'}}  onChange={e=>{HandleData(e);}} name="info_tech" className="UserInput"/>
                </div>
                <div className="DivInput">
                    <label>Paiements :</label>
                    <div  className="Div-UserInput" style={{border:'none'}}>
                        <div className="PaiementCheckBox">
                            <input onChange={e=>{HandleModesPaiement(e)}} value="Paypal" type="checkbox" /><span>Paypal</span>
                        </div>
                        <div className="PaiementCheckBox">
                            <input onChange={e=>{HandleModesPaiement(e)}} checked value="Cash" type="checkbox" /><span>Cash</span>
                        </div>
                    </div>
                </div>
                <div className="DivInput">
                    <label>{t('ajout-produit.images')}</label>
                        <input style={{borderColor:InputColors.images,minHeight:'0px',borderRadius:'0px'}} accept="image/png,image/jpeg,image/jpg" onChange={e=>{setArticle({...article,images:[...e.target.files]});}} multiple type="file" name="images" className="UserInput"/>
                        <div style={{marginTop:'10px',textAlign:'right',marginRight:'30px'}}>
                            {article.images.map((image,index)=>{
                                return(
                                <div style={{display:'inline-block',border:'1px solid lightgray',marginLeft:'10px',padding:'5px 10px 5px 10px',borderRadius:'5px',verticalAlign:'middle',position:'relative'}}>
                                    <img key={index} style={{width:"100px",display:'inline-block',marginLeft:'10px'}} src={FormatImage(image)}  />
                                    <span onClick={e=>{RemoveImageFile(image)}} className='remove-file' style={{position:'absolute',top:'5px',right:'5px'}}>x</span>
                                </div>)
                            })}
                    </div>
                </div>
                <div className="DivInput">
                    <label>{t('ajout-produit.documents')}</label>
                    <input style={{minHeight:'0px',borderRadius:'0px'}} onChange={e=>{setArticle({...article,documents:[...e.target.files]});}} multiple accept="application/pdf" name="documents" type="file" className="UserInput"/>
                    <div style={{marginTop:'10px',textAlign:'right',marginRight:'30px'}}>
                        {article.documents.map((doc)=>{
                            return(
                                <div style={{display:'inline-block',padding:'5px 10px 5px 10px',backgroundColor:'lightgray',borderRadius:'5px'}}><span>{doc.name}</span>
                                <span onClick={e=>{RemoveDocumentFile(doc)}} className='remove-file' style={{marginLeft:'10px'}}>x</span></div>
                            )
                        })}
                    </div>
                </div>
                {/*ShowArticle()*/}
                {SubmitBtns()}
                <div style={{textAlign:'center',border:'none',display:notification.display}} className='DivInput'>
                    <p style={{color:notification.color}}>{notification.text}</p>
                </div>
        </fieldset>
    </div>
  )
}

export default AjoutArticle
